import { formatNumber } from './formatNumber';

/**
 * If the coop has Extra units for acopio, make the conversion to the extra unit and return the formatted value
 * with the extra unit abbreviation
 * @param {number} unidadAcopio
 * @param {object} coopConfig
 * @returns {string} the formatted value with the extra unit abbreviation
 */
const unidadAcopioConvertible = (unidadAcopio, coopConfig, withUnits = true, division = false) => {
  // Helper function to determine precision based on decimal places
  const getPrecision = num => {
    const numStr = num.toString();
    const decimalIndex = numStr.indexOf('.');
    if (decimalIndex === -1) return 2; // No decimal point, use 2
    const decimalPlaces = numStr.length - decimalIndex - 1;
    return decimalPlaces > 2 ? 4 : 2;
  };
  let units = withUnits ? coopConfig.acopioUnits()?.abreviacion : '';

  if (coopConfig.hasAcopioUnitsExtra()) {
    let convertedUnit;
    if (division) {
      convertedUnit = Number(unidadAcopio) / (coopConfig.acopioUnitsConversion()?.conversion || 1);
    } else {
      convertedUnit = Number(unidadAcopio) * (coopConfig.acopioUnitsConversion()?.conversion || 1);
    }
    units = withUnits ? coopConfig.acopioUnitsExtra()?.abreviacion : '';
    const dynamicPrecision = getPrecision(convertedUnit || 0);
    return formatNumber(convertedUnit || 0, dynamicPrecision) + ' ' + units;
  }
  const dynamicPrecision = getPrecision(unidadAcopio || 0);

  return formatNumber(unidadAcopio || 0, dynamicPrecision) + ' ' + units;
};

export default unidadAcopioConvertible;
